/**
 * Calculate category averages for CIS standards
 * @param {Array} items - Array of processed items
 * @param {Object} cisStandardData - CIS standard data
 * @returns {Object} - Category averages
 */
(function($) {
	function calculateCategoryAverages(items, cisStandardData) {
	const categoryScores = {};
	const categoryPotentialCounts = {};
	
	// First gather potential counts from CIS standard data if available
	if (cisStandardData && cisStandardData.CS && cisStandardData.CS.Items) {
		cisStandardData.CS.Items.forEach(control => {
			if (control.controlid && control.controlid.S) {
				const safeguardId = control.controlid.S;
				const category = safeguardId.split('.')[0]; // Get the category (e.g., 14 from 14.1)
				
				if (!categoryPotentialCounts[category]) {
					categoryPotentialCounts[category] = 0;
				}
				categoryPotentialCounts[category]++;
			}
		});
	}
	// console.log("Category potential counts: ", categoryPotentialCounts);
	
	// Initialize category scores structure with potential counts
	Object.keys(categoryPotentialCounts).forEach(category => {
		categoryScores[category] = { 
			total: 0, 
			count: 0, 
			nullCount: 0, 
			totalItems: 0,
			applicableItems: 0,
			potentialCount: categoryPotentialCounts[category]
		};
	});
	
	// Process actual score data
	items.forEach(item => {
		const safeguardId = item.safeguardid.S;
		const category = safeguardId.split('.')[0]; // Get the category (e.g., 14 from 14.1)
		const maturityScore = item.maturityscore; // Can be null
		const policystatus = parseInt(item.policystatus.N, 10);
		
		if (!categoryScores[category]) {
			categoryScores[category] = { 
				total: 0, 
				count: 0, 
				nullCount: 0, 
				totalItems: 0,
				applicableItems: 0,
				potentialCount: categoryPotentialCounts[category] || 0
			};
		}
		
		categoryScores[category].totalItems++;
		
		// Check if item is Not Applicable (policy status 1)
		if (policystatus === 1) {
			categoryScores[category].nullCount++;
		} else {
			// Item is applicable (whether filled out or not)
			categoryScores[category].applicableItems++;
			
			// Only add to total if it has a maturity score
			if (maturityScore !== null) {
				categoryScores[category].total += maturityScore;
				categoryScores[category].count++;
			}
		}
	});
	
	// Calculate averages using potential count minus NA items as denominator
	const averages = {};
	Object.keys(categoryScores).forEach(category => {
		const { total, count, nullCount, totalItems, applicableItems, potentialCount } = categoryScores[category];
		
		// If all items in category are marked as "Not Applicable" (policy status 1), set average to null
		if (nullCount === totalItems && totalItems > 0) {
			averages[category] = null;
		} else {
			// Denominator should be the total possible safeguards minus NA items
			// This ensures unanswered questions are counted in the denominator
			// If we have potentialCount from standards, use that minus nullCount
			// Otherwise fall back to applicableItems
			const denominator = potentialCount > 0 ? (potentialCount - nullCount) : applicableItems;
			averages[category] = denominator > 0 ? total / denominator : 0;
			// console.log(`Category ${category}: total=${total}, potentialCount=${potentialCount}, nullCount=${nullCount}, denominator=${denominator}, applicableItems=${applicableItems}, actual count=${count}, average=${averages[category]}`);
		}
	});
	
	// console.log("Category averages: ", averages);
	
	return averages;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = calculateCategoryAverages;
	} else if (typeof window !== 'undefined') {
		window.calculateCategoryAverages = calculateCategoryAverages;
	}

})(jQuery);
